import React, { FC, useMemo, useState } from 'react';
import { ServiceProviderInterface } from '../interfaces';
import { uk } from '../lang';

const { createContext, useContext } = React;

interface TranslationServiceInterface {
	lang: 'uk' | 'en';
	t: (str: string) => string;
	setLang: (lang: 'uk' | 'en') => void;
}

interface TranslationProviderInterface extends ServiceProviderInterface {}

const translate =
	(lang: 'uk' | 'en') =>
	(str: string): string => {
		if (lang === 'en') return str;
		return uk[str];
	};

const TranslationContext = createContext<TranslationServiceInterface>(
	{} as TranslationServiceInterface
);

export const TranslationProvider: FC<TranslationProviderInterface> = (props) => {
	const [lang, setLang] = useState<'uk' | 'en'>('uk');
	const value = useMemo(
		() => ({
			lang,
			setLang: (lng: 'uk' | 'en') => {
				setLang(lng);
			},
			t: translate(lang),
		}),
		[lang]
	);

	return (
		<TranslationContext.Provider value={value}>
			{props.children}
		</TranslationContext.Provider>
	);
};

export const useTranslation = () => {
	return useContext(TranslationContext);
};
